import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg10Mwt = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 23.161,
	height: 20.645,
	viewBox: "0 0 23.161 20.645",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			id: "Path_467",
			"data-name": "Path 467",
			d: "M393.83,147.717a2.336,2.336,0,0,0-1.605-.923l-2.579-.305a2.791,2.791,0,0,0-.5-.972,2.77,2.77,0,1,0-3.525-1.015c-.153.015-.306.031-.457.056l-2.683.44a2.4,2.4,0,0,0-1.9,1.644l-1.039,3.026a2.363,2.363,0,0,0,3.353,2.779,2.322,2.322,0,0,0,1.151-1.351l.619-1.674.386-.061v2.217l-.964,3.182-1.768.928a2.348,2.348,0,1,0,2.194,4.152l2.388-1.27a2.928,2.928,0,0,0,1.149-1.1l.3,1.534a2.352,2.352,0,1,0,4.617-.9l-.778-3.982a.749.749,0,0,0-.265-.435l-2.169-2.17v-.261l1.914.227a2.393,2.393,0,0,0,.282.017,2.356,2.356,0,0,0,1.878-3.774Zm-5.878-5.964a1.269,1.269,0,1,1-1.269,1.269A1.27,1.27,0,0,1,387.952,141.752Zm-1.123,14.819a1.428,1.428,0,0,1-.631.673l-2.388,1.27a.849.849,0,1,1-.793-1.5l2.046-1.074a.752.752,0,0,0,.369-.446l.243-.8,1.25,1.029Zm3.937-1.934.732,3.745a.853.853,0,0,1-1.674.327l-.575-2.945a.751.751,0,0,0-.227-.407l-2.469-2.278v-4.6a.75.75,0,0,0-.866-.741l-1.687.267a.749.749,0,0,0-.586.48l-.783,2.121a.864.864,0,0,1-1.659-.482l1.039-3.027a.9.9,0,0,1,.711-.624l2.684-.44a5.7,5.7,0,0,1,.925-.075h.629a1.3,1.3,0,0,1,1.3,1.3v4.558a.749.749,0,0,0,.22.53Zm2.028-5.365a.855.855,0,0,1-.947.713l-1.945-.23v-1.727l2.147.254a.857.857,0,0,1,.745.99Z",
			transform: "translate(-371.143 -140.253)",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_468",
			"data-name": "Path 468",
			d: "M366.452,181.82c.009-.023.015-.048.022-.072s.015-.045.02-.068a.768.768,0,0,0,.014-.143v0h0a.772.772,0,0,0-.015-.147c0-.021-.012-.04-.018-.06a.7.7,0,0,0-.025-.08c-.01-.023-.023-.044-.034-.066s-.021-.043-.034-.063a.75.75,0,0,0-.086-.105l-.007-.009-1.967-1.967a.778.778,0,0,0-.992-.111.75.75,0,0,0-.1,1.142l.717.717h-5.845a.79.79,0,0,0-.8.64.75.75,0,0,0,.742.859h5.9l-.684.684a.781.781,0,0,0-.073,1.049.75.75,0,0,0,1.1.043l1.995-1.994a.762.762,0,0,0,.1-.116c.011-.016.018-.034.028-.051A.813.813,0,0,0,366.452,181.82Z",
			transform: "translate(-357.299 -164.35)",
			fill: "current"
		})
	]
});
const ForwardRef = forwardRef(Svg10Mwt);
export { ForwardRef as ReactComponent };
